<template>
    <ResourceInput
        label="Slug"
        attribute="slug"
    />
</template>
